<section class="section-card">
  <div class="section-card__head" *ngIf="title">
    <h2 class="section-card__title">{{ title }}</h2>
  </div>
  <div class="section-card__body">
    <ng-content></ng-content>
  </div>
</section>
